<div class="pp_overlay" (click)='cancelPopup()' *ngIf='popupVisible'>
    <div class="pp_container" (click)="$event.stopPropagation()">
        <ng-content></ng-content>
    </div>
</div>
